import { render, staticRenderFns } from "./Flavors.vue?vue&type=template&id=aeb8891c&"
import script from "./Flavors.vue?vue&type=script&lang=js&"
export * from "./Flavors.vue?vue&type=script&lang=js&"
import style0 from "./Flavors.vue?vue&type=style&index=0&id=aeb8891c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports